import initSchemaLogger, { Logger } from '@wix/bi-logger-cashier-ugc';
import { iframeAppBiLoggerFactory } from '@wix/iframe-app-bi-logger';
import webBiLogger from '@wix/web-bi-logger';
import { wixSdkAdapter } from './wixSdkAdapter';

type BIDefaults = { [key: string]: any | (() => any) };

let biDefaults: BIDefaults = {};

export const updateBiDefaults = (defaults: BIDefaults): void => {
  biDefaults = {
    ...biDefaults,
    ...defaults,
  };
};

export const resetBiDefaults = (): void => {
  biDefaults = {};
};

export const getBiLogger = (): Logger => {
  const factory = wixSdkAdapter.isAvailable()
    ? iframeAppBiLoggerFactory(wixSdkAdapter.Wix)
    : webBiLogger;
  const biLogger = initSchemaLogger(factory)();

  biLogger.util.updateDefaults(biDefaults);

  return biLogger;
};
